import { ViewModelComponentProps } from '@/utils/typeUtilities'
import UtilityProgramEligibleDeviceEnrollmentFlowStepRoot, {
  Props as ComponentProps,
} from './UtilityProgramEligibleDeviceEnrollmentFlowStep'
import useViewModel from './useViewModel'
import { UtilityProgram } from '@/types/utilityProgram'

export type Props = ViewModelComponentProps<
  ComponentProps,
  typeof useViewModel
> & {
  hideTitle?: boolean
  utilityProgram?: UtilityProgram
}

export default function UtilityProgramEligibleDeviceEnrollmentFlowStep(
  props: Props,
) {
  const viewModel = useViewModel(props)
  return (
    <UtilityProgramEligibleDeviceEnrollmentFlowStepRoot
      {...viewModel}
      {...props}
    />
  )
}
